export const COMMIT_HASH = "a0230d77d6f821cb705d76731b1f32d9902ae9bc";
export const SHORTBREAD_VERSION = "1.1.2.1";
